/**
 * Helper functions for template state management
 * Used by templateSlice.ts reducers
 */

const metricsToRows = (metrics) => {
  return metrics.map((metric) => ({
    TableTitle: metric.TableTitle,
    Id: metric.Id,
    GeographyId: metric.geographyId,
    SourceId: metric.sourceId,
    ChartTitle: metric.ChartTitle,
    HasData: metric.HasData,
    Precision: metric.Precision,
    Row: metric.Row,
    Style: metric.Style,
    Level: metric.Level,
    Values: metric.Values,
    Type: metric.Type,
  }));
};

const metricsToCharted = (metrics) => {
  const charted = {};
  for (const metric of metrics) {
    const row = {
      IsCharted: metric.IsCharted,
    };
    charted[metric.Row] = row;
  }
  return charted;
};

const metricsToData = (metrics) => {
  const Data = {};
  for (const metric of metrics) {
    const DataRow = {
      ChartTitle: metric.ChartTitle,
      Color: metric.ChartColor,
      GeographyId: metric.GeographyId,
      formattedName: metric.ChartTitle ? metric.ChartTitle : metric.Name,
      HasData: metric.HasData,
      Id: metric.Id,
      Level: metric.Level,
      Precision: metric.Precision,
      Row: metric.Row,
      SourceId: metric.SourceId,
      Style: metric.Style,
      TableTitle: metric.TableTitle,
      Type: metric.Type,
      Values: metric.Values,
    };
    Data[metric.Row] = DataRow;
  }
  return Data;
};

const createTopics = (template) => {
  const searchTerms = template.SearchTerms ? template.SearchTerms.toLowerCase().split('|') : [];
  const subjectTags = template.SubjectTags ? template.SubjectTags.toLowerCase().split('|') : [];

  return Array.from(new Set(searchTerms.concat(subjectTags)));
};

/**
 * Updates template state from API response
 * Used by both template_load and template_load_timeframe fulfilled reducers
 */
export const updateTemplateState = (state, result) => {
  state.id = result.Id;
  state.name = result.Title;
  state.note = result.Notes;
  state.methodology = result.Methodology;
  state.additionalNote = result.AdditionalNotes;
  state.publicationDate = result.PublicationDate;
  state.lastModifiedTimestamp = result.LastModifiedTimestamp;
  state.source = result.Source;
  state.topics = createTopics(result);
  state.comparativeEstimates = result.ComparativeEstimates;
  state.titleInTable = result.TitleInTable;
  state.subtitleInTable = result.Subtitle;
  state.chartedLength = result.chartedLength ?? result.Headers.length;
  state.tableRows = metricsToRows(result.Metrics);
  state.metricScaleMode = result.MetricScaleMode;
  state.period = result.Period;
  state.availableTimes = result.PeriodsWithDataAvailable;
  state.headers = result.Headers;
  state.charted = metricsToCharted(result.Metrics);
  state.chartYear = result.Chart.Year;
  state.chartType = result.Chart.ChartType;
  state.titleInChart = result.TitleInChart;
  state.subtitleInChart = result.SubtitleInChart;
  state.geography = result.Geography;
  state.data = metricsToData(result.Metrics);
  state.logoType = result.Chart.LogoType ?? 'dual';
  state.loading = false;
  state.loaded = true;
  state.maxReached = result.Chart.ChartType !== 'horizontalBar';
};
